import React, { useEffect } from 'react';
import DemoHomeworkScheduleDetail from '../demo/DemoHomeworkScheduleDetail';

const LiteStudents = ({ user, onLogout }) => {
  useEffect(() => {
    const uid = user?.uid;
    if (!uid) return;
    localStorage.setItem(`studentProfileMode_${uid}`, 'supply_teacher');
    localStorage.setItem(`readingAgeMode_${uid}`, 'lower');
  }, [user?.uid]);

  return <DemoHomeworkScheduleDetail user={user} onLogout={onLogout} routeNamespace="lite" />;
};

export default LiteStudents;
